import { WEEKDAY } from '../exported-types';
export const DEFAULT_WEEK_START = WEEKDAY.MONDAY;
export const WEEK_LENGTH = 7;
export const WEEKS_PER_CALENDAR_MONTH = 6;
export const ALL_WEEKDAYS = [
    WEEKDAY.SUNDAY,
    WEEKDAY.MONDAY,
    WEEKDAY.TUESDAY,
    WEEKDAY.WEDNESDAY,
    WEEKDAY.THURSDAY,
    WEEKDAY.FRIDAY,
    WEEKDAY.SATURDAY,
];
